import React from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";

import { setUser, getUser } from "../util/Utility";
import Cookie from "../util/Cookie";
import config from "../Config";
import {checkForCookieEnabled} from "../util/CookieEnable";

export default Component => {
    
    class WithLogin extends React.Component {

        componentWillMount() {
            const {history} = this.props;
            if(!checkForCookieEnabled()){
                history.push("/play/enable-cookie");
            } else {
                var authToken = Cookie.get("X-Reycreo-Auth-Token");
                var userId = Cookie.get("X-Reycreo-Id");
                if (userId && authToken) {
                    setUser({userId:userId, authToken: authToken});
                } else {
                    if(window && window.navigator && window.navigator.connection && window.navigator.connection.saveData){
                        history.push("/play/data-saver");
                    } else {
				let langId=Cookie.get("X-Reycreo-Language-Id");
				console.log("Country Id ",langId);
				let host = window.location.hostname;
		        	let subDomain = host.split('.')[0];
        		    let SUB =`${config.NON_WIFI_OP}`;
        		    let SUBU2 =`${config.NON_WIFI_OP_U2}`;
                    
		            let SEND_TO_BILLING =`${config.NO_LOGIN_OP}`;
			        let CG_FLOW=`${config.CG_FLOW_OP}`;
                    console.log("vodatest subDomain ",subDomain,SUB.includes(subDomain) )
                    console.log("vodatest SEND_TO_BILLING",SEND_TO_BILLING,SEND_TO_BILLING.includes(subDomain))
                    console.log("vodatest CG_FLOW",CG_FLOW)
                    console.log("SUB : ", SUB);
                    console.log("SUBu2 : ", SUBU2);
//if(Cookie.get("X-Reycreo-Operator-Id") =='U2OPIADUMMY' || Cookie.get("X-Reycreo-Operator-Id")=='VFGH' ){
//console.log("REDIRECT TO LOGIN , withLogin");
  //                              window.location.href = `${config.BILLING_URL}/login`;}	
	//if(SUB.includes(subDomain) Cookie.get("X-Reycreo-Operator-Id")=='U2OPIADUMMY' ){
if(SUB.includes(subDomain)  ){          
         // if(SUB.includes(subDomain) || SUBU2.includes(subDomain) ){
if(Cookie.get("X-Reycreo-Operator-Id") =='U2OPIADUMMY' || Cookie.get("X-Reycreo-Operator-Id")=='VFGH' ){
		console.log("Mujhe kuch nahi aata , withLogin");
                window.location.href = `${config.BILLING_URL}/login`;
	}else {
	history.push("/play/no-data");
	}		
//		history.push("/play/no-data");
			}else if(SEND_TO_BILLING.includes(subDomain) ){
	                	let operatorId = SEND_TO_BILLING.split('_')[1];
        		        console.log(" operatorId : Login ",operatorId);
        	        	Cookie.setToPath('X-Reycreo-Operator-Id', operatorId,"."+host.split('.')[1]+"."+host.split('.')[2]);
		                window.location.href = `${config.BILLING_URL}/billing`;
            		}else if (CG_FLOW.includes(subDomain)&&(langId===null)){
        		        console.log(" NO_LOGIN ",config.BILLING_URL);
		                window.location.href = `${config.BILLING_URL}`;

			}else{
				console.log("REDIRECT TO LOGIN , withLogin");
                		window.location.href = `${config.BILLING_URL}/login`;
            		}
            
                    }
                }
                
            }
        }

        render() {
            if(getUser()){
                return <Component
                    {...this.props}
                />
            } else {
                return null;
            }
        }
    }

    return withRouter(connect((state) => {
        return {}
    }, {})(WithLogin));
}



// WEBPACK FOOTER //
// ./src/components/WithLogin.js